// extracted by mini-css-extract-plugin
export var divider = "_3o-0";
export var dividerText = "_3o-2";
export var dividerVertical = "_3o-1";